var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8GithubFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.792,
    height: 16.792,
    viewBox: "0 0 16.792 16.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e4e4e4;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8_github_1",
    className: "cls-1",
    d: "M12.4,4a8.4,8.4,0,1,0,8.4,8.4A8.406,8.406,0,0,0,12.4,4Zm0,1.259a7.138,7.138,0,0,1,2.1,13.959V17.071a2.058,2.058,0,0,0-1.13-1.832,4.058,4.058,0,0,0,2.912-2,2.786,2.786,0,0,0-.339-3.059,2.906,2.906,0,0,0-.1-2.37A2.344,2.344,0,0,0,13.977,8.87a5.118,5.118,0,0,0-3.163,0A2.343,2.343,0,0,0,8.954,7.81a2.4,2.4,0,0,0-.029,2.283,2.8,2.8,0,0,0-.438,3.1,4.037,4.037,0,0,0,2.935,2.051,2.061,2.061,0,0,0-1.085,1.418H9.786a1.167,1.167,0,0,1-1.05-.594,1.9,1.9,0,0,0-.978-.728c-.2-.021-.339.132-.162.269.6.406.637,1.069.876,1.5a1.409,1.409,0,0,0,1.167.744H10.3v1.365A7.138,7.138,0,0,1,12.4,5.259Z",
    transform: "translate(-4 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GithubFooter);
export default __webpack_public_path__ + "static/media/icons8_github_Footer.945ddb1b02dd956a419cf9efd9549cda.svg";
export { ForwardRef as ReactComponent };